class ShareService {
    private map: Map<string, any>;
 
    constructor() {
        this.map = new Map<string, any>();
    }
 
    setMapValue(key: string, value: any): void {
        this.map.set(key, value);
    }
 
    getMapValue(key: string): any | null {
        if (this.map.has(key)) {
            return this.map.get(key);
        } else {
            return null;
        }
    }
 
    clearMap(): void {
        this.map.clear();
    }
 
    deleteMapValue(key: string): void {
        if (this.map.has(key)) {
            this.map.delete(key);
        }
    }
}
 
export default new ShareService();
 